/** @jsx jsx */
/** @jsxFrag null */
import { jsx } from 'panel';
import { ButtonEl } from 'common/components/button';
import { ButtonTheme } from 'common/components/button/constants';
import { DashboardFavoriteButton } from 'apps/boards/src/dashboards-app/components/buttons';
import { LocalizationStore } from 'common/i18n/store';
import styles from './report-saving-text.inline.styl';
export function QueryReportHeaderTitle(_ref: {
  isSavingChanges: boolean;
  canEditActiveDashboard: boolean;
  i18n: LocalizationStore;
}) {
  let {
    isSavingChanges,
    canEditActiveDashboard,
    i18n
  }: {
    isSavingChanges: boolean;
    canEditActiveDashboard: boolean;
    i18n: LocalizationStore;
  } = _ref;
  return isSavingChanges && canEditActiveDashboard && <>
        <style>{styles}</style>
        <div sel='.report-saving-text'>{i18n.t("boards.header.saving")}</div>
      </>;
}
export function QueryReportHeaderActionItems(_ref2: {
  dashboardLoaded: boolean;
  isEmbedMode: boolean;
  isActiveDashboardFavorited: boolean;
  isFavoriteRequestLoading: boolean;
  onHeaderFavoriteDashboard: () => Promise<void>;
  onRefresh: () => void;
  onExitTvMode: () => void;
  i18n: LocalizationStore;
}) {
  let {
    dashboardLoaded,
    isEmbedMode,
    isActiveDashboardFavorited,
    isFavoriteRequestLoading,
    onHeaderFavoriteDashboard,
    onRefresh,
    onExitTvMode,
    i18n
  }: {
    dashboardLoaded: boolean;
    isEmbedMode: boolean;
    isActiveDashboardFavorited: boolean;
    isFavoriteRequestLoading: boolean;
    onHeaderFavoriteDashboard: () => Promise<void>;
    onRefresh: () => void;
    onExitTvMode: () => void;
    i18n: LocalizationStore;
  } = _ref2;
  return <>
      {dashboardLoaded && !isEmbedMode && <DashboardFavoriteButton isSelected={isActiveDashboardFavorited} isLoading={isFavoriteRequestLoading} onClick={onHeaderFavoriteDashboard} i18n={i18n} />}
      <ButtonEl attrs={{
      icon: "refresh",
      theme: ButtonTheme.Tertiary,
      slot: "tvRefresh"
    }} on={{
      click: onRefresh
    }} data-sentry-element="ButtonEl" data-sentry-source-file="query-report-header-mixins.tsx" />

      <ButtonEl attrs={{
      icon: "x",
      theme: ButtonTheme.Secondary,
      slot: "tvExit"
    }} on={{
      click: onExitTvMode
    }} data-sentry-element="ButtonEl" data-sentry-source-file="query-report-header-mixins.tsx">
        {i18n.t("boards.actions.tv-mode-exit")}
      </ButtonEl>
    </>;
}